export default __webpack_public_path__ + "static/media/smartSearch_ua_d.f7dd1afd.svg";